import { RootState } from './../../app/store';

export const selectTags = (state: RootState) => state.tags;
export const selectCurrentTag = (state: RootState) => state.tags.find(tag => tag.isActive);